module.exports = __webpack_public_path__ + "img/sphere1.77b75a37.png";